import { useEffect, useState } from "react";
import Modal from "react-modal";
import { useFetch } from "../custom/api";
import LoadingComp from "./LoadingComp";
import AchievementModal from "./achievements/AchievementModal";
import { toFarsiNumber } from "../custom/helpers";
import "../styles/Modals.css";
import "../styles/Challenges.css";
import "../styles/Achievements.css";

const VISIBLE_LIMIT = 6;

// Lightweight public-profile preview - opened from a leaderboard row. Only
// GET users/{user_id}/achievements is available for another user (no
// locked/progress info, per the API's privacy rules), so this only ever
// shows what they've earned.
function UserProfilePreviewModal({ show, onClose, userId, name }) {
  const { myFetch } = useFetch();
  const [data, setData] = useState(undefined); // undefined = loading
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (!show || !userId) return;
    let ignore = false;
    setData(undefined);
    const run = async () => {
      const resp = await myFetch(`users/${userId}/achievements`, { method: "GET" });
      const r = await resp.json();
      if (!ignore) setData(r);
    };
    run();
    return () => {
      ignore = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, userId]);

  const displayName = (data && data.user && data.user.name) || name || "کاربر فودپلنر";
  const initial = (displayName || "?").trim().charAt(0);
  const earned = (data && data.earned) || [];
  const visible = earned.slice(0, VISIBLE_LIMIT);
  const extra = earned.length - visible.length;

  return (
    <>
      <Modal isOpen={!!show} onRequestClose={onClose} className="modal" overlayClassName="overlay">
        <div className="modal-header">
          <h2>پروفایل کاربر</h2>
          <a onClick={onClose}>
            <span className="icon-iconclose rectangle-1 heading-1 grey-3"></span>
          </a>
        </div>
        <div className="modal-body centerAlign">
          <span className="leaderboardAvatar userPreviewAvatar" aria-hidden="true">
            {initial}
          </span>
          <p className="heading-3 marginTop5 yekan">{displayName}</p>

          {data === undefined ? (
            <LoadingComp />
          ) : (
            <>
              <p className="caption-1 grey-2 yekan marginTop5">
                🏆 دستاورد‌ها ({toFarsiNumber(data.total_earned || 0)})
              </p>

              {visible.length === 0 ? (
                <p className="caption-1 grey-2 yekan marginTop5">هنوز دستاوردی به دست نیومده</p>
              ) : (
                <div className="achievementGrid achievementGrid-preview marginTop5">
                  {visible.map((a) => (
                    <button
                      key={a.achievement_id}
                      type="button"
                      className={`achievementCard achievementCard-sm achievementCard-earned achRarity-${
                        a.rarity || "common"
                      }`}
                      onClick={() => setSelected({ ...a, earned: true })}
                    >
                      <span className="achievementCardIcon" aria-hidden="true">
                        {a.icon && a.icon.trim() ? a.icon : "🏆"}
                      </span>
                      <span className="achievementCardName yekan">{a.name}</span>
                    </button>
                  ))}
                </div>
              )}

              {extra > 0 && <p className="caption-1 grey-2 marginTop5">+{toFarsiNumber(extra)} بیشتر</p>}

              <p className="subject-1 purple-1 marginTop5" style={{ fontWeight: "bold" }}>
                {toFarsiNumber(data.total_points || 0)} امتیاز
              </p>
            </>
          )}
        </div>
      </Modal>

      <AchievementModal achievement={selected} onClose={() => setSelected(null)} />
    </>
  );
}

export default UserProfilePreviewModal;
